// extracted by mini-css-extract-plugin
module.exports = {"container":"score_container__2sl9C","wrapper":"score_wrapper__3BK1T"};